import styled from 'styled-components';

export const SUserListItemTextWrapper = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;
`;

